export enum SelectorType {
    RADIO,
    CHECKBOX,
}
